import apiClient from './apiClient';

export const getAllRoleGroups = async () => {
  const response = await apiClient.post('/role/GetAllRoleGroups');
  return response.data.Data.Items || [];
};

export const addRoleGroup = async (roleGroup) => {
  const response = await apiClient.post('/role/AddRoleGroup', roleGroup);
  return response.data;
};

export const updateRoleGroup = async (roleGroup) => {
  const response = await apiClient.post('/role/UpdateRoleGroup', roleGroup);
  return response.data;
};

export const deleteRoleGroup = async (id) => {
  const response = await apiClient.post('/role/DeleteRoleGroup', null, { params: { id } });
  return response.data;
};
